/* eslint-disable camelcase */
import React from 'react';
import { Designer } from '@graphql/Designer/queries/availableDesigners.graphql';
import DefaultTemplate from '@components/shared/templates/DefaultTemplate/DefaultTemplate';
import { IPrismicText, IPrismicImage, IPrismicUrl } from '@lib/prismic/types';
import FullBleedHero from '@components/shared/Hero/FullBleedHero/FullBleedHero';
import ExploreDesigners, { IPrismicCategoryGroup } from './ExploreDesigners/ExploreDesigners';
import Designers from '../../shared/Designers/Designers';
import FindYourStyle from './FindYourStyle/FindYourStyle';
import infiniteInteriorDesignerScroll from './infiniteInteriorDesignerScroll';

export type { IPrismicText, IPrismicImage } from '@lib/prismic/types';

export interface IPrismicLink {
  id: string;
  uid: string;
}
interface IPrismicData {
  by_location: IPrismicCategoryGroup;
  by_style: IPrismicCategoryGroup;
  designers_subheader: IPrismicText[];
  designers_description: IPrismicText[];
  hero_image: IPrismicImage;
  hero_subtitle: IPrismicText[];
  hero_title: IPrismicText[];
  hero_cta_link: IPrismicUrl;
  hero_cta_logged_in_link: IPrismicUrl;
  hero_cta_text: IPrismicText[];
  location_title: IPrismicText[];
  main_hero_image: IPrismicImage;
}

interface IInteriorDesignersProps {
  prismicData: IPrismicData;
  cities: string[];
  designers: Designer[];
  roomTypeIds: number[];
  styleIds: number[];
}

const InteriorDesigners = ({
  prismicData,
  cities,
  designers,
  roomTypeIds,
  styleIds
}: IInteriorDesignersProps) => {
  const {
    by_location, // don't break Prismic. Change when feasible.
    by_style,
    designers_subheader,
    designers_description,
    hero_image,
    hero_cta_link,
    hero_cta_logged_in_link,
    hero_cta_text,
    hero_subtitle,
    hero_title,
  } = prismicData;
  const {
    designers: designerSet,
    loading,
    loadingMore
  } = infiniteInteriorDesignerScroll(styleIds, roomTypeIds, designers);

  return (
    <DefaultTemplate
      data-test="interior-designers"
      title="Interior Designers"
      navProps={{
        isFixed: true,
        isTransparent: true
      }}
    >
      <FullBleedHero
        hero_title={hero_title}
        hero_subtitle={hero_subtitle}
        hero_cta_text={hero_cta_text}
        hero_cta_link={hero_cta_link}
        hero_cta_logged_in_link={hero_cta_logged_in_link}
        main_hero_image={hero_image}
      />
      <ExploreDesigners byLocation={by_location} byStyle={by_style} />
      <Designers
        cities={cities}
        title={designers_subheader}
        subtitle={designers_description}
        designers={designerSet}
        isLoading={loading || loadingMore}
      />

      <FindYourStyle />
    </DefaultTemplate>
  );
};

export default InteriorDesigners;
